import { connect } from 'react-redux';
import { compose, withProps, withHandlers } from 'recompose';
import FileSaver from 'file-saver';
import to from 'await-to-js';
import { withReportSaving, withReportValidation } from '../report/report.helper';
import { container } from 'op/container';
export const withPendingReports = compose(
    connect(({ reports, person }) => ({
        people: person.loaded || [],
        pending: (reports.editing || []),
        history: (reports.submitted || []),
    }), (dispatch) => ({
        clearAndExit: (report) => {
            dispatch(container.resolve('actions').remove_report(report));
        }
    })),
    withReportSaving,
    withHandlers({
        downloadReport: ({ report, downloadReport, setSubmitting }) => async (report, person, languageID) => {
            const [err, success] = await to(downloadReport(report, person, languageID));
            if (!success || err) {
                console.error(err);
            } else {
                FileSaver.saveAs(success.data, `Report_${person.name}.pdf`);
            }
        },
        deleteReport: ({ report, deleteReportFromPending, clearAndExit, setSubmitting }) => async (report) => {
            const [err, success] = await to(deleteReportFromPending(report));
            if (!success || err) {
                console.error(err);
            } else {
                clearAndExit(report);
            }
        },
    })
);
